//constant used with scroll links to accomodate navbar
export const SECTION_OFFSET = -65;
